export function isFreeCancellation({ percent }: CancelCondition): boolean {
  return percent === 0
}

export function getFreeCancellationRange(
  conditions: CancelCondition[],
): number {
  return conditions.find(isFreeCancellation)?.to ?? 0
}
